<template>
  <div>
    <ts-loading-banner :loading="waiting">
      <div class="ts-h-screen">
        <div class="h-100">
          <!-- BEGIN pos -->
          <div class="pos pos-customer" v-bind:class="{ 'pos-mobile-sidebar-toggled': posMobileSidebar }"
            id="pos-customer">
            <PosMenu :current-time="currentTime" :current-date="currentDate" :exchange-rate="exchangeRate"
              :to-currency="toCurrency" :company-logo="companyLogo" :product-category="productCategories"
              :locale="locale" @back-home="backHome" @change-category="onChangeCategory" />

            <PosContent :sub-categories="subCategories" :categories="categories" :active-key="activeKey"
              :active-key-category="activeKeyCategory" :mode="mode" :products="products" :data-send="dataSend"
              :locale="locale" :fullscreen="fullscreen" :product-fetching="productFetching"
              :product-category="productCategories" :fetch-options="fetchOptions" @search-barcode="searchBarcode"
              @open-fullscreen="openFullscreen" @close-fullscreen="closeFullscreen" @select-product="selectProduct"
              @add-product="addProduct" @increase-quantity="increaseQuantity" @decrease-quantity="decreaseQuantity"
              @remove-product="removeProduct" @change-sub-category="onChangeSubCategory"
              @change-main-category="onChangeMainCategory" @update-search-value="updateSearchValue" />
            <PosSidebar :table-selected="tableSelected" :data-send="dataSend" :locale="locale" :vat-rate="vatRate"
              :default-currency="defaultCrrency" :waiting="waiting" :errors="errors" ref="posSidebar"
              @pos-mobile-sidebar-toggled="posMobileSidebarToggled" @change-language="changeLanguage"
              @check-bill="checkBill" @submit-order="submitOrder" @remove-item="removeItem"
              @set-promotion-item-free-item="handlePromotionItemFreeItem"
              @set-promotion-discount-ordered="setPromotionDiscountOrdered" />

            <MobileSidebarToggler :data-send="dataSend" @pos-mobile-sidebar-toggled="posMobileSidebarToggled" />

            <ProductModal :selected-product="selectedProduct" :data-send="dataSend" :default-currency="defaultCrrency"
              :quantity="quantity" :discount-rate="discountRate" :size="size" :addon="addon" :remarks="remarks"
              @close="close" @increment="increment" @decrement="decrement" @update-quantity="quantity = $event"
              @update-discount-rate="discountRate = $event" @update-addon="addon = $event"
              @update-remarks="remarks = $event" @choose-size="chooseSize" @choose-add-on="chooseAddOn"
              @add-to-cart="addToCart" />

            <PromotionModal :visible="visible" :promotion-free-item-per-amount="promotion_free_item_per_amount"
              :conditions="conditions" :waiting="waiting" :selected-product-free="selectedProductFree"
              :checked-all="checkedAll" @handle-ok="handleOk" @handle-cancel="handleCancel" @select-all="selectAll" />
          </div>

          <!-- Pre-Charge Product Selection Modal -->
          <PreChargeProductModal :show="showPreChargeModal" :products="preChargeProductOptions" :data-send="dataSend"
            @product-selected="handleProductSelected" @close="handleModalClose" />

          <!-- END pos -->
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { debounce, orderBy } from 'lodash'

// Import components
import PosMenu from './components/PosMenu.vue'
import PosContent from './components/PosContent.vue'
import PosSidebar from './components/PosSidebar.vue'
import MobileSidebarToggler from './components/MobileSidebarToggler.vue'
import ProductModal from './components/ProductModal.vue'
import PromotionModal from './components/PromotionModal.vue'
// Import the modal component
import PreChargeProductModal from './components/PreChargeProductModal.vue'

export default {
  name: 'CustomerOrder',
  components: {
    PosMenu,
    PosContent,
    PosSidebar,
    MobileSidebarToggler,
    ProductModal,
    PromotionModal,
    PreChargeProductModal
  },
  data() {
    return {
      // Add initialization guard
      isComponentInitialized: false,
      timeInterval: null,

      activeKey: '',
      activeKeyCategory: '',
      mode: 'top',
      errors: new Errors(),
      posMobileSidebar: false,
      loading: false,
      waiting: false,
      visible: false,
      checkedAll: false,
      productFetching: false,
      showChooseFreeItems: true,
      selectedProductId: null,
      quantity: 1,
      size: null,
      selectedProductFree: [],
      addon: [],
      products: [],
      subCategories: [],
      categories: [],
      remarks: null,
      discountRate: null,
      discount_type: null,
      promo_type_id: null,
      currentTime: '',
      currentDate: '',
      promotion_free_item_per_amount: {},
      conditions: {},
      fetchOptions: {
        search_value: ''
      },
      item: {
        product_id: null,
        uom_id: null,
        quantity: null,
        unit_price: null,
        discount_type: null,
        discount_rate: null,
        discount_amount: null,
        total_after_discount: null,
        vat_rate: null,
        vat_amount: null,
        grand_total: null,
        remarks: null,
        promo_free_item_cond_id: null,
        promo_type_id: null,
        is_allow_adjust_free_quantity: false,
        is_pre_charge: false,
        max_person: null,
        service_length: null
      },
      itemAddon: [],
      dataSend: {
        customer_id: null,
        stock_out_id: null,
        counter_id: null,
        table_id: null,
        num_customer: null,
        order_no: null,
        sub_total: 0,
        discount_type: null,
        discount_rate: null,
        discount_amount: null,
        total_after_discount: 0,
        vat_amount: 0,
        vat_rate: 0,
        grand_total: 0,
        fx_rate: 0,
        remark: null,
        products: [],
        guest_level_id: null,
        total_pre_charge_amount: 0,
        main_linked_key: null,
        ref_customer_member_card_id: null,
        pre_charge_payment_method: null,
        pre_charge_bank_id: null,
        pre_charge_bank_account_number: null,
      },
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ],
      product_id_delete: null,
      uom_id_delete: null,
      quantity_delete: null,
      unit_price_delete: null,
      fullscreen: false,
      category_id: null,
      pro_group_id: null,
      showPreChargeModal: false,
      preChargeProductOptions: []
    }
  },
  computed: {
    ...mapGetters('restaurantSale/customerOrder', [
      'defaultPrice',
      'productPriceScheme',
      'saleCodeByDefaultUom',
      'getUomName',
      'getProduct',
      'getPromotionDiscount',
      'getPromotionDiscountDisplay',
      'getPromotionItemFreeItem',
      'getPromotionBuyItemFreeItem',
      'getPromotionFreeItemPerAmount'
    ]),
    ...mapState('restaurantSale/customerOrder', ['companyInfo']),

    // RENAME this computed property to avoid conflict with data property
    productCategories() {
      const category_id = this.$store.state.restaurantSale.customerOrder.products
        .filter(
          p =>
            _.includes([1, 2], p.product_type_id) && p.is_pre_charge === false
        )
        .map(p => p.category_id)

      return (
        this.$store.state.restaurantSale.customerOrder.productCategories.filter(
          cat => category_id.includes(cat.category_id)
        ) || []
      )
      // return (
      //   this.$store.state.restaurantSale.customerOrder.productCategories || []
      // )
    },

    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    companyLogo() {
      return this.companyInfo && this.companyInfo.length > 0
        ? this.companyInfo[0].company_logo
        : ''
    },
    selectedProduct() {
      return this.$store.state.restaurantSale.customerOrder.products.filter(
        s => s.product_id == this.selectedProductId
      )
    },
    vatRate() {
      const settings = this.$store.state.restaurantSale.customerOrder
        .systemSettings
      return parseFloat(settings && settings.vat_rate ? settings.vat_rate : 0)
    },
    exchangeRate() {
      const settings = this.$store.state.restaurantSale.customerOrder
        .systemSettings
      return parseFloat(settings && settings.fx_rate ? settings.fx_rate : 0)
    },
    defaultCrrency() {
      const settings = this.$store.state.restaurantSale.customerOrder
        .systemSettings
      return settings && settings.default_currency
        ? settings.default_currency
        : ''
    },
    toCurrency() {
      const settings = this.$store.state.restaurantSale.customerOrder
        .systemSettings
      return settings && settings.to_currency ? settings.to_currency : ''
    },
    locale() {
      return this.$root.$i18n.locale
    },
    flag() {
      if (this.$root.$i18n.locale === 'kh') return 'kh'
      else if (this.$root.$i18n.locale === 'en') return 'us'
      return 'us'
    }
  },
  async created() {
    // MAIN FIX: Prevent duplicate initialization
    if (this.isComponentInitialized) {
      // console.log('Duplicate created() call prevented - UID:', this._uid)
      return
    }

    // console.log('Component created - UID:', this._uid, 'Timestamp:', Date.now())

    try {
      await this.initializeComponent()
    } catch (error) {
      // console.error('Error initializing component:', error)
      this.productFetching = false
    }
  },

  async beforeDestroy() {
    // console.log('Component destroying - UID:', this._uid)
    this.cleanup()
  },
  methods: {
    ...mapActions('restaurantSale/customerOrder', ['fetchBefore', 'store']),
    async initializeComponent() {
      // Mark as initialized first to prevent re-entry
      this.isComponentInitialized = true

      PageOptions.pageEmpty = true
      this.productFetching = true

      if (_.isEmpty(this.tableSelected)) {
        this.$router.push({ name: 'counter-checkout' })
        return
      }

      await this.fetchBefore().then(async () => {
        // FIXED: Only call autoAddPreChargeProducts after successful initialization
        this.onChangeCategory(null)
        this.setDataOnSelectedTable()
        this.handleAutoAddPreChargeProducts()
        this.productFetching = false
      })

      this.checkReload()
      this.setupPeriodicTimer()
      this.dataSend.counter_id = parseInt(
        localStorage.getItem('counterId') || '0'
      )
    },

    setupPeriodicTimer() {
      // Clear any existing interval first
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
      this.timeInterval = setInterval(() => this.updateCurrentTime(), 1000)
    },

    cleanup() {
      // Clean up interval
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
        this.timeInterval = null
      }

      // Reset initialization flag
      this.isComponentInitialized = false

      // Clean up window event
      window.onbeforeunload = null
    },

    // MAIN FIX: Enhanced pre-charge handling with multiple prevention methods
    handleAutoAddPreChargeProducts() {
      // Method 1: Check if pre-charge products already exist in cart
      if (this.hasPreChargeInCart()) {
        // console.log('Pre-charge products already in cart, skipping auto-add')
        return
      }

      // Method 2: Check session flag
      if (this.isPreChargeProcessedForSession()) {
        // console.log('Pre-charge already processed for this session, skipping')
        return
      }

      // Method 3: Check if this is an existing order (has invoice_detail)
      if (
        this.tableSelected &&
        this.tableSelected.invoice_detail &&
        this.tableSelected.invoice_detail.length > 0
      ) {
        // console.log('Existing order detected, skipping pre-charge auto-add')
        return
      }

      // Method 3: Check if this is an linked from main key (has main_linked_key)
      if (this.tableSelected && this.tableSelected.main_linked_key) {
        return
      }

      this.autoAddPreChargeProducts()
    },

    hasPreChargeInCart() {
      const preChargeProducts = this.getPreChargeProducts()
      if (preChargeProducts.length === 0) return false

      const cartItems = this.dataSend.products || []
      return cartItems.some(cartItem =>
        preChargeProducts.some(
          preProduct => preProduct.product_id === cartItem.product_id
        )
      )
    },

    isPreChargeProcessedForSession() {
      const tableId =
        (this.tableSelected && this.tableSelected.table_id) || 'default'
      const sessionKey = `precharge_processed_${tableId}`
      return sessionStorage.getItem(sessionKey) === 'true'
    },

    markPreChargeAsProcessed() {
      const tableId =
        (this.tableSelected && this.tableSelected.table_id) || 'default'
      const sessionKey = `precharge_processed_${tableId}`
      sessionStorage.setItem(sessionKey, 'true')
    },

    clearPreChargeProcessedSession() {
      try {
        const keys = Object.keys(sessionStorage)
        const prechargeKeys = keys.filter(key =>
          key.startsWith('precharge_processed_')
        )

        prechargeKeys.forEach(key => {
          sessionStorage.removeItem(key)
        })

        // console.log(`Cleared ${prechargeKeys.length} precharge sessions`)
      } catch (error) {
        // console.error('Error clearing all precharge sessions:', error)
      }
    },

    getPreChargeProducts() {
      const products =
        (this.$store.state.restaurantSale &&
          this.$store.state.restaurantSale.customerOrder &&
          this.$store.state.restaurantSale.customerOrder.products) ||
        []
      return products.filter(product => product.is_pre_charge === true)
    },

    // Method to handle auto-adding pre-charge products
    autoAddPreChargeProducts() {
      const preChargeProducts = this.getPreChargeProducts()

      if (preChargeProducts.length === 0) {
        // console.log('No pre-charge products found')
        return
      }

      if (preChargeProducts.length === 1) {
        // console.log(
        //   'Auto-adding single pre-charge product:',
        //   preChargeProducts[0].product_name_en
        // )
        this.addPreChargeProduct(preChargeProducts[0])
        this.markPreChargeAsProcessed()
      } else {
        // console.log(
        //   'Multiple pre-charge products found, showing selection modal'
        // )

        this.showPreChargeSelectionModal(preChargeProducts)
        this.markPreChargeAsProcessed()
      }
    },

    // Method to add a pre-charge product to cart
    addPreChargeProduct(product) {
      // console.log('Adding pre-charge product ID:', product.product_id)
      this.addProduct(product.product_id)
    },

    // Method to show modal for pre-charge product selection
    showPreChargeSelectionModal(products) {
      this.preChargeProductOptions = products
      this.showPreChargeModal = true
    },

    // Method called when user selects a product from the modal
    handleProductSelected(selectedProduct) {
      this.addPreChargeProduct(selectedProduct)
    },

    // Method to close the pre-charge selection modal
    handleModalClose() {
      this.showPreChargeModal = false
      this.preChargeProductOptions = []
    },

    checkReload() {
      window.onbeforeunload = function () {
        return 'Are you sure you want to close the window?'
      }
    },

    // ... Rest of your existing methods remain unchanged ...
    // Copy all your existing methods here: posMobileSidebarToggled, searchBarcode,
    // onChangeCategory, selectProduct, addProduct, etc.

    posMobileSidebarToggled: function () {
      this.posMobileSidebar = !this.posMobileSidebar
    },

    searchBarcode() {
      var product = this.$store.state.restaurantSale.customerOrder.products
        .filter(
          p =>
            p.barcode == this.fetchOptions.search_value ||
            p.product_name_en == this.fetchOptions.search_value ||
            p.product_name_kh == this.fetchOptions.search_value
        )
        .reduce((init, value) => (init = value), null)
      if (product) {
        this.selectProduct(product.product_id)
        this.addToCart()
        this.fetchOptions.search_value = ''
      } else {
        this.$notification['info']({
          message: 'Search Barcode',
          description: 'Not found product!',
          placement: 'buttomRight'
        })
        this.fetchOptions.search_value = ''
      }
    },

    onChangeCategory(category_id) {
      this.category_id = category_id
      this.categories = []
      this.subCategories = []
      this.activeKey = ''
      this.activeKeyCategory = ''
      this.fetchOptions.search_value = ''
      if (category_id) {
        const category = this.productCategories.find(
          c => c.category_id == category_id
        )
        this.subCategories = category ? category.sub_categories || [] : []
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            _.includes([1, 2], p.product_type_id) &&
            p.category_id == category_id &&
            p.is_pre_charge === false
        )

        const pro_group_id = this.products.map(
          p => p.product_group.pro_group_id
        )

        this.subCategories =
          this.subCategories.filter(sc =>
            pro_group_id.includes(sc.pro_group_id)
          ) || []

        return
      }
      this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
        p =>
          _.includes([1, 2], p.product_type_id) &&
          _.includes(
            p.sale_code.map(s => s.is_top_sale),
            true
          ) &&
          p.is_pre_charge === false
      )
      this.categories = this.productCategories.filter(c =>
        _.includes(_.uniq(this.products.map(p => p.category_id)), c.category_id)
      )
      this.subCategories = []
      return
    },

    onChangeSubCategory(pro_group_id) {
      this.fetchOptions.search_value = ''
      if (pro_group_id) {
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            _.includes([1, 2], p.product_type_id) &&
            p.product_group.pro_group_id == pro_group_id &&
            p.is_pre_charge === false
        )
        return
      }
    },

    onChangeMainCategory(category_id) {
      this.fetchOptions.search_value = ''
      if (category_id) {
        this.products = this.$store.state.restaurantSale.customerOrder.products.filter(
          p =>
            p.category_id == category_id &&
            _.includes([1, 2], p.product_type_id) &&
            _.includes(
              p.sale_code.map(s => s.is_top_sale),
              true
            ) &&
            p.is_pre_charge === false
        )
        return
      }
    },

    selectProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
    },

    addProduct(product_id) {
      this.clearOldSelectPro()
      this.selectedProductId = product_id
      let saleCode = this.saleCodeByDefaultUom(product_id)
      this.size = saleCode.unit_of_measure.uom_id
      this.chooseSize(saleCode)
      this.addToCart()
    },

    // Include all your other existing methods...
    // For brevity, I'm not copying all methods, but you should include:
    // setPromotionDiscount, setPromotionDiscountOrdered, clearOldSelectPro,
    // increment, decrement, chooseSize, chooseAddOn, addToCart, etc.

    updateCurrentTime() {
      this.currentDate = moment().format('dddd, MMM Do')
      this.currentTime = moment().format('LT')
    },
    setPromotionDiscount(product_id, uom_id, quantity) {
      const promotion_discount = this.getPromotionDiscount(
        product_id,
        uom_id,
        quantity,
        this.tableSelected.guest_level_id
      )

      this.remarks = promotion_discount
        ? promotion_discount.promotion_name
        : null

      this.discountRate = promotion_discount
        ? promotion_discount.discount_rate // ✅ use correct field
        : null

      this.promo_type_id = promotion_discount
        ? promotion_discount.promo_type_id
        : null

      this.discount_type = promotion_discount
        ? promotion_discount.discount_type // ✅ include if you display/type discount
        : null
    },
    setPromotionDiscountOrdered(order) {
      const promotion_discount = this.getPromotionDiscount(
        order.product_id,
        order.uom_id,
        order.quantity,
        this.tableSelected.guest_level_id
      )

      order.remarks = promotion_discount
        ? promotion_discount.promotion_name
        : null

      order.discount_rate = promotion_discount
        ? promotion_discount.discount_rate // ✅ per-item rate
        : null

      order.promo_type_id = promotion_discount
        ? promotion_discount.promo_type_id
        : null

      order.discount_type = promotion_discount
        ? promotion_discount.discount_type // ✅ include if used
        : null
    },
    clearOldSelectPro() {
      this.quantity = 1
      this.size = null
      this.addon = []
      this.remarks = null
      this.discountRate = null
      this.promo_type_id = null
      this.itemAddon = []
    },
    increment() {
      this.quantity++
    },
    decrement() {
      this.quantity--
    },
    chooseSize(saleCode) {
      this.addItem(saleCode)
    },
    chooseAddOn(saleCode) {
      this.addItem(saleCode, true)
    },
    addToCart() {
      //clear search value when click add product
      this.fetchOptions.search_value = ''
      var dis = this.dataSend.products
        .filter(p => p.product_id == this.item.product_id)
        .reduce((init, value) => (init = value.discount_rate), 0)
      this.item.quantity = this.quantity
      this.item.promo_free_item_cond_id = null
      this.$forceUpdate()
      let var_product = this.dataSend.products
        .filter(
          p =>
            p.product_id == this.item.product_id &&
            p.uom_id == this.item.uom_id &&
            p.unit_price > 0 &&
            (this.tableSelected.linked_keys.length > 0
              ? p.ref_table_id == null
              : true == true)
        )
        .reduce((init, value) => (init = value), {})
      if (!_.isEmpty(var_product)) {
        var_product.quantity += this.item.quantity
        this.setPromotionDiscount(
          this.item.product_id,
          this.item.uom_id,
          var_product.quantity
        )
        var_product.discount_rate = this.discountRate ? this.discountRate : dis
        var_product.discount_type = this.discount_type ? this.discount_type : '%'
        var_product.remarks = this.remarks
        this.calculate()
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          var_product.quantity
        )
        //move to index 0
        this.arraymove(
          this.dataSend.products,
          this.dataSend.products.indexOf(var_product),
          this.dataSend.products.length + 1
        )
      } else {
        this.setPromotionDiscount(
          this.item.product_id,
          this.item.uom_id,
          this.item.quantity
        )
        this.item.discount_rate = this.discountRate
        this.item.discount_type = this.discount_type ? this.discount_type : '%'
        this.item.promo_type_id = this.promo_type_id
        this.item.remarks = this.remarks
        this.dataSend.products.push(_.clone(this.item))
        this.dataSend.vat_rate = parseFloat(
          this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
        )
        this.setPromotionItemFreeItem(
          this.item.product_id,
          this.item.uom_id,
          this.item.unit_price,
          this.item.quantity
        )
      }
      this.itemAddon.forEach(el => {
        let duplicate = this.dataSend.products.filter(
          p => p.product_id == el.product_id && p.uom_id == el.uom_id
        )
        if (duplicate.length > 0) {
          duplicate[0].quantity += el.quantity
          //move to index 0
          this.arraymove(
            this.dataSend.products,
            this.dataSend.products.indexOf(duplicate[0]),
            this.dataSend.products.length + 1
          )
        } else {
          this.dataSend.products.push(_.clone(el))
        }
      })
      this.close()
      this.scrollToBottom()
    },
    handlePromotionItemFreeItem(event) {
      this.setPromotionItemFreeItem(
        event.product_id,
        event.uom_id,
        event.unit_price,
        event.quantity
      )
    },
    setPromotionItemFreeItem(product_id, uom_id, unit_price, quantity) {
      if (unit_price > 0) {
        var free_item = this.getPromotionItemFreeItem(
          product_id,
          uom_id,
          quantity
        )
        if (free_item) {
          free_item.map(el => {
            if (el.quantity > 0) {
              let var_product = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(var_product)) {
                var_product.quantity = el.quantity
                this.arraymove(
                  this.dataSend.products,
                  this.dataSend.products.indexOf(var_product),
                  this.dataSend.products.length + 1
                )
              } else {
                this.item.product_id = el.product_id
                this.item.uom_id = el.uom_id
                this.item.quantity = el.quantity
                this.item.unit_price = el.unit_price
                this.item.discount_rate = 0
                this.item.remarks = el.promotions.promotion_name
                this.item.promo_type_id = el.promotions.promo_type_id
                this.item.is_allow_adjust_free_quantity =
                  el.is_allow_adjust_free_quantity
                this.dataSend.products.push(_.clone(this.item))
              }
            } else {
              let checkExists = this.dataSend.products
                .filter(
                  p =>
                    p.product_id == el.product_id &&
                    p.uom_id == el.uom_id &&
                    p.promo_type_id == el.promotions.promo_type_id
                )
                .reduce((init, value) => (init = value), {})

              if (!_.isEmpty(checkExists)) {
                this.dataSend.products.splice(
                  this.dataSend.products.indexOf(checkExists),
                  1
                )
              }
            }
          })
        }
      }
    },
    addItem(saleCode, add_on_type = false) {
      const productPriceScheme = this.productPriceScheme(
        saleCode.product_id,
        this.dataSend.guest_level_id,
        saleCode.uom_id
      )
      if (!add_on_type) {
        this.item.product_id = saleCode.product_id
        this.item.uom_id = saleCode.uom_id
        this.item.quantity = this.quantity
        this.item.unit_price = productPriceScheme.unit_price
        this.item.max_person = productPriceScheme.max_person
        this.item.service_length = productPriceScheme.service_length
        this.item.is_pre_charge = productPriceScheme.is_pre_charge
        this.item.discount_type = this.discount_type ? this.discount_type : '%'
        this.item.discount_rate = this.discountRate
        this.item.remarks = this.remarks
        this.item.discount_amount = 0
        this.item.total_after_discount = 0
        this.item.vat_rate = 0
        this.item.vat_amount = 0
        this.item.grand_total = 0
      } else {
        let checkExists = this.itemAddon
          .filter(
            i =>
              i.product_id == saleCode.product_id && i.uom_id == saleCode.uom_id
          )
          .reduce((init, value) => (init = value), {})
        if (!_.isEmpty(checkExists)) {
          this.itemAddon.splice(this.itemAddon.indexOf(checkExists), 1)
          return
        }
        this.itemAddon.push({
          product_id: saleCode.product_id,
          uom_id: saleCode.uom_id,
          quantity: 1,
          unit_price: saleCode.product_price
            ? saleCode.product_price.sale_price
            : 0,
          discount_type: '%',
          discount_rate: 0,
          remarks: null,
          discount_amount: 0,
          total_after_discount: 0,
          vat_rate: 0,
          vat_amount: 0,
          grand_total: 0
        })
      }
    },
    calculate() {
      let lineGrandTotalSum = 0
      let discountTotal = 0
      let totalAfterDiscountSum = 0

      this.dataSend.products.forEach(el => {
        const amount = _.round(el.quantity * el.unit_price, 2)

        // Discount
        const discountAmount =
          el.discount_type === '%'
            ? _.round(amount * (el.discount_rate / 100), 2)
            : _.round(el.discount_rate, 2)

        const totalAfterDiscount = _.round(amount - discountAmount, 2)

        // VAT per line (for detail only)
        const vatAmount = _.round(totalAfterDiscount * (el.vat_rate / 100), 2)

        const lineGrandTotal = _.round(totalAfterDiscount + vatAmount, 2)

        // Assign back to item
        el.amount = amount
        el.discount_amount = discountAmount
        el.total_after_discount = totalAfterDiscount
        el.vat_amount = vatAmount
        el.grand_total = lineGrandTotal

        // Accumulate
        discountTotal += discountAmount
        totalAfterDiscountSum += totalAfterDiscount
        lineGrandTotalSum += lineGrandTotal
      })

      const preCharge = !this.dataSend.main_linked_key
        ? parseFloat(this.dataSend.total_pre_charge_amount || 0)
        : parseFloat(0)

      // Apply exchange rate
      this.dataSend.fx_rate = _.round(this.exchangeRate, 4)

      // ✅ Main totals
      this.dataSend.sub_total = _.round(totalAfterDiscountSum - preCharge, 2) // net amount after discount
      this.dataSend.discount = _.round(discountTotal, 2)
      this.dataSend.total_after_discount = _.round(
        totalAfterDiscountSum - preCharge,
        2
      )

      // VAT calculated at main level (not sum of details)
      this.dataSend.vat_amount = _.round(
        this.dataSend.total_after_discount * (this.vatRate / 100),
        2
      )

      // ✅ Grand total includes VAT
      this.dataSend.grand_total = _.round(
        this.dataSend.sub_total + this.dataSend.vat_amount,
        2
      )

      this.removeFreeItemPerAmount()
    },
    setDataOnSelectedTable() {
      if (!_.isEmpty(this.tableSelected)) {
        console.log(this.tableSelected);

        this.dataSend.table_id = this.tableSelected.table_id
        this.dataSend.stock_out_id = this.tableSelected.stock_out_id
        this.dataSend.num_customer = this.tableSelected.num_customer
          ? this.tableSelected.num_customer
          : this.$store.state.restaurantSale.counterCheckout.num_customer
        this.dataSend.order_no = this.tableSelected.order_no
        this.dataSend.sub_total = this.tableSelected.sub_total
        this.dataSend.discount = this.tableSelected.discount
        this.dataSend.total_after_discount = this.tableSelected.total_after_discount
        this.dataSend.vat_amount = this.tableSelected.vat_amount
        this.dataSend.vat_rate = this.vatRate
        this.dataSend.grand_total = this.tableSelected.invoice_amount
        this.dataSend.fx_rate = this.exchangeRate
        this.dataSend.remark = this.tableSelected.remark
        this.dataSend.products = this.tableSelected.invoice_detail
        this.dataSend.guest_level_id = this.tableSelected.guest_level_id
        this.dataSend.total_pre_charge_amount = parseFloat(
          this.tableSelected.total_pre_charge_amount
        )
        if (this.tableSelected.invoice_detail.length > 0) {
          this.showChooseFreeItems = false
        }
        this.dataSend.main_linked_key = this.tableSelected.main_linked_key
        this.dataSend.customer_id = this.tableSelected.customer_id
        this.dataSend.ref_customer_member_card_id = this.tableSelected.ref_customer_member_card_id
        this.dataSend.pre_charge_payment_method = this.tableSelected.pre_charge_payment_method
        this.dataSend.pre_charge_bank_id = this.tableSelected.pre_charge_bank_id
        this.dataSend.pre_charge_bank_account_number = this.tableSelected.pre_charge_bank_account_number
      }
    },
    async removeItem(row) {
      let item
      item = {
        product_id: row.product_id,
        uom_id: row.uom_id,
        stock_out_id: row.stock_out_id,
        quantity: row.quantity,
        order_status: null,
        ref_table_id: row.ref_table_id
      }
      this.dataSend.products.splice(this.dataSend.products.indexOf(row), 1)

      if (!row.stock_out_id) {
        item = {
          product_id: row.product_id,
          uom_id: row.uom_id,
          stock_out_id: this.dataSend.stock_out_id,
          quantity: row.quantity,
          order_status: 'Not submit order'
        }
      }

      // if (row.stock_out_id) {
      await this.$store
        .dispatch('restaurantSale/customerOrder/deleteItemOrdered', item)
        .catch(error => {
          this.dataSend.products.push(row)
          this.$toasted.error(error.messages)
        })
      // } else {
      //   this.dataSend.products.splice(this.dataSend.products.indexOf(row), 1)
      // }
      this.product_id_delete = null
      this.uom_id_delete = null
      this.quantity_delete = null
      this.unit_price_delete = null
      // remove promotion item
      var free_item = this.getPromotionItemFreeItem(
        row.product_id,
        row.uom_id,
        row.quantity
      )
      if (free_item) {
        free_item.map(el => {
          if (el.quantity > 0) {
            let checkExists = this.dataSend.products
              .filter(
                p =>
                  p.product_id == el.product_id &&
                  p.uom_id == el.uom_id &&
                  p.promo_type_id == el.promotions.promo_type_id
              )
              .reduce((init, value) => (init = value), {})

            if (!_.isEmpty(checkExists)) {
              this.dataSend.products.splice(
                this.dataSend.products.indexOf(checkExists),
                1
              )
            }
          }
        })
      }
    },
    close() {
      this.$bvModal.hide('modalPosItem')
    },
    updateCurrentTime() {
      this.currentDate = moment().format('dddd, MMM Do')
      this.currentTime = moment().format('LT')
    },
    checkBill() {
      this.$router.push({ name: 'counter-checkout' })
    },
    submitOrder() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount && this.showChooseFreeItems) {
        this.conditions = this.promotion_free_item_per_amount.conditions
        if (this.conditions.free_status == 'All') {
          this.selectAll(true)
        } else {
          this.selectAny()
        }
        this.visible = true
        return
      }

      this.waiting = true
      this.store(
        Object.assign({}, this.dataSend, {
          counter_id: parseInt(localStorage.getItem('counterId')),
          action_type: 'submit-order',
          submit_from: 'cashier'
        })
      )
        .then(async () => {
          const endedServices = (this.dataSend.products || []).filter(
            p => p.service_length && p.start_time && p.end_time
          )
          if (endedServices.length) {
            await Promise.all(endedServices.map(item =>
              this.$store.dispatch('restaurantSale/counterCheckout/serviceDurationDetail', {
                stock_out_id: this.dataSend.stock_out_id,
                product_id: item.product_id,
                ref_table_id: item.ref_table_id,
                service_length: item.service_length,
                is_pre_charge: !!item.is_pre_charge,
                action_type: 'restart-time'
              }).catch(err => console.error('restart-time failed:', err))
            ))
          }
          this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
            .finally(() => {
              this.clearInput()
              this.waiting = false
              this.$router.push({ name: 'counter-checkout' })
            })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          if (this.errors.first('change_in_usd')) {
            this.$notification['error']({
              message: 'PAYMENT',
              description: this.errors.first('change_in_usd'),
              placement: 'bottomRight'
            })
          } else {
            this.$notification['error']({
              message: 'ORDER',
              description: error.message,
              placement: 'bottomRight'
            })
          }
        })
    },
    selectAll(e) {
      if (e) {
        this.selectedProductFree = []
        this.conditions.discount_items.map(el => {
          this.selectedProductFree.push({
            product_id: el.product_id,
            uom_id: el.uom_id,
            quantity: el.quantity
          })
          this.checkedAll = true
        })
      } else {
        this.selectedProductFree = []
      }
    },
    selectAny() {
      this.selectedProductFree = []
      this.selectedProductFree.unshift({
        product_id: this.conditions.discount_items[0].product_id,
        uom_id: this.conditions.discount_items[0].uom_id,
        quantity: this.conditions.discount_items[0].quantity
      })
    },
    handleOk(e) {
      this.selectedProductFree.forEach(el => {
        let var_product = this.dataSend.products
          .filter(
            p =>
              p.product_id == el.product_id &&
              p.uom_id == el.uom_id &&
              p.unit_price == 0 &&
              p.promo_type_id == el.promo_type_id
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(var_product)) {
          var_product.quantity += el.quantity
          //move to index 0
          this.arraymove(
            this.dataSend.products,
            this.dataSend.products.indexOf(var_product),
            this.dataSend.products.length + 1
          )
        } else {
          this.item.product_id = el.product_id
          this.item.uom_id = el.uom_id
          this.item.quantity = el.quantity
          this.item.unit_price = 0
          this.item.discount_rate = 0
          this.item.promo_type_id = this.promotion_free_item_per_amount.promo_type_id
          this.item.remarks = this.promotion_free_item_per_amount.promotion_name
          this.item.promo_free_item_cond_id = this.conditions.promo_free_item_cond_id
          this.dataSend.products.push(_.clone(this.item))
        }
      })
      this.showChooseFreeItems = false
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    },
    removeFreeItemPerAmount() {
      this.promotion_free_item_per_amount = this.getPromotionFreeItemPerAmount(
        this.dataSend.sub_total
      )
      if (this.promotion_free_item_per_amount) {
        let checkExists = this.dataSend.products
          .filter(
            p =>
              p.promo_free_item_cond_id !=
              this.promotion_free_item_per_amount.conditions
                .promo_free_item_cond_id &&
              p.promo_free_item_cond_id != null &&
              p.promo_type_id ==
              this.promotion_free_item_per_amount.promo_type_id &&
              p.unit_price == 0
          )
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      } else {
        let checkExists = this.dataSend.products
          .filter(p => p.promo_free_item_cond_id != null && p.unit_price == 0)
          .reduce((init, value) => (init = value), {})

        if (!_.isEmpty(checkExists)) {
          this.dataSend.products.splice(
            this.dataSend.products.indexOf(checkExists),
            1
          )
          this.showChooseFreeItems = true
        }
      }
    },
    clearInput() {
      this.dataSend.customer_id = null
      this.dataSend.table_id = null
      this.dataSend.num_customer = 0
      this.dataSend.order_no = null
      this.dataSend.sub_total = 0
      this.dataSend.discount = 0
      this.dataSend.total_after_discount = 0
      this.dataSend.vat_amount = 0
      this.dataSend.vat_rate = 0
      this.dataSend.grand_total = 0
      this.dataSend.fx_rate = 0
      this.dataSend.remark = null
      this.dataSend.guest_level_id = null
      this.dataSend.total_pre_charge_amount = 0
      this.dataSend.products = []

      this.itemAddon = []
      this.selectedProductFree = []
    },
    backHome() {
      PageOptions.pageEmpty = false
      this.$router.push('/')
    },
    callback(val) {
      // console.log(val)
    },
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    arraymove(arr, fromIndex, toIndex) {
      var element = arr[fromIndex]
      arr.splice(fromIndex, 1)
      arr.splice(toIndex, 0, element)
    },
    changeLanguage(language) {
      this.$root.$i18n.locale = language.code
    },
    scrollToBottom() {
      this.$nextTick(() => {
        // Access the ref through the component
        const posSidebar = this.$refs.posSidebar
        if (posSidebar && posSidebar.$refs.add_to_card) {
          posSidebar.$refs.add_to_card.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest'
          })
        }
      })
    },
    orderBy(items) {
      return orderBy(items, ['display_order'])
    },
    isAllowAdjustFreeQuantity(order) {
      if (
        (order.promo_type_id == 2 || order.promo_type_id == 4) &&
        !order.is_allow_adjust_free_quantity
      ) {
        return true
      }
      return false
    },
    openFullscreen() {
      if (!this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      let elem = document.documentElement

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        /* Firefox */
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        elem.msRequestFullscreen()
      }
    },

    closeFullscreen() {
      if (this.fullscreen) {
        this.fullscreen = !this.fullscreen
      }
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    },
    updateSearchValue(searchValue) {
      this.fetchOptions.search_value = searchValue
    },
    chooseSize(saleCode) {
      this.addItem(saleCode)
      // Also update the size prop for the radio button selection
      this.size = saleCode.unit_of_measure.uom_id
    },
    // Handle increasing quantity from floating controls
    increaseQuantity(product_id) {
      let uom_id = this.saleCodeByDefaultUom(product_id).unit_of_measure.uom_id
      let existingProduct = this.dataSend.products.find(
        p =>
          p.product_id == product_id &&
          p.unit_price > 0 &&
          p.uom_id == uom_id &&
          (this.tableSelected.linked_keys.length > 0
            ? p.ref_table_id == null
            : true == true)
      )

      if (existingProduct) {
        existingProduct.quantity += 1
        this.setPromotionDiscount(
          existingProduct.product_id,
          existingProduct.uom_id,
          existingProduct.quantity
        )
        existingProduct.discount_rate = this.discountRate
          ? this.discountRate
          : existingProduct.discount_rate
        existingProduct.remarks = this.remarks
        this.calculate()
        this.setPromotionItemFreeItem(
          existingProduct.product_id,
          existingProduct.uom_id,
          existingProduct.unit_price,
          existingProduct.quantity
        )
        // Move to top of list
        this.arraymove(
          this.dataSend.products,
          this.dataSend.products.indexOf(existingProduct),
          this.dataSend.products.length + 1
        )
      }
    },

    // Handle decreasing quantity from floating controls
    decreaseQuantity(product_id) {
      let uom_id = this.saleCodeByDefaultUom(product_id).unit_of_measure.uom_id
      let existingProduct = this.dataSend.products.find(
        p =>
          p.product_id == product_id &&
          p.unit_price > 0 &&
          p.uom_id == uom_id &&
          (this.tableSelected.linked_keys.length > 0
            ? p.ref_table_id == null
            : true == true)
      )

      if (existingProduct && existingProduct.quantity > 1) {
        existingProduct.quantity -= 1
        this.setPromotionDiscount(
          existingProduct.product_id,
          existingProduct.uom_id,
          existingProduct.quantity
        )
        existingProduct.discount_rate = this.discountRate
          ? this.discountRate
          : existingProduct.discount_rate
        existingProduct.remarks = this.remarks
        this.calculate()
        this.setPromotionItemFreeItem(
          existingProduct.product_id,
          existingProduct.uom_id,
          existingProduct.unit_price,
          existingProduct.quantity
        )
        // Move to top of list
        this.arraymove(
          this.dataSend.products,
          this.dataSend.products.indexOf(existingProduct),
          this.dataSend.products.length + 1
        )
      }
    },

    // Handle removing product completely from floating controls
    removeProduct(product_id) {
      let existingProduct = this.dataSend.products.find(
        p =>
          p.product_id == product_id &&
          p.unit_price > 0 &&
          (this.tableSelected.linked_keys.length > 0
            ? p.ref_table_id == null
            : true == true)
      )

      if (existingProduct) {
        this.removeItem(existingProduct)
      }
    }
  },
  watch: {
    dataSend: {
      handler() {
        this.calculate()
      },
      deep: true
    },
    activeKey: function (val) {
      this.onChangeSubCategory(val)
    },
    activeKeyCategory: function (val) {
      this.onChangeMainCategory(val)
    },
    'fetchOptions.search_value': debounce(function (search) {
      if (search) {
        this.category_id = null
        this.pro_group_id = null
        this.products = this.$store.state.restaurantSale.customerOrder.products
          .filter(
            p =>
              _.includes([1, 2], p.product_type_id) && p.is_pre_charge == false
          )
          .filter(
            p =>
              p.barcode
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              p.product_name_en
                .toLowerCase()
                .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1 ||
              (p.product_name_kh
                ? p.product_name_kh
                  .toLowerCase()
                  .indexOf(this.fetchOptions.search_value.toLowerCase()) > -1
                : false)
          )
      } else {
        this.onChangeCategory(this.category_id)
        if (this.pro_group_id) {
          this.onChangeSubCategory(this.pro_group_id)
        }
      }
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    this.clearPreChargeProcessedSession()
    next()
  }
}
</script>

<style scoped>
/* Keep your existing styles */
.pos-product-img .img {
  object-fit: cover;
  width: 100%;
}

.pos-product-thumb .img {
  object-fit: cover;
  width: 100%;
}

.pos-customer .pos-sidebar .pos-sidebar-body .pos-table {
  padding: 0 10px;
}

.pos-customer .pos-sidebar .pos-sidebar-body .pos-table .pos-table-row {
  padding: 10px 0;
}

.form-group {
  margin-bottom: 0.3rem;
}

.border-bottom {
  border-bottom: 1px solid #74b1f1 !important;
}

.pos-customer .pos-menu .logo {
  padding: 12px;
}

.pos-customer .pos-menu .logo .logo-img {
  text-align: center;
  height: 105px;
}

.nav-container {
  position: relative;
}

.nav-container .nav.nav-tabs {
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
}

.nav-container .nav.nav-tabs::-webkit-scrollbar {
  display: none;
}

.nav-container .nav.nav-tabs {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.nav-container .next-button {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 100%;
  background: #fff;
  box-shadow: -5px 0 5px rgba(0, 0, 0, 0.05);
  text-align: center;
  line-height: 50px;
  cursor: pointer;
  z-index: 999;
}
</style>
